import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["GridEvent"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getGridEvent: build.query<GetGridEventApiResponse, GetGridEventApiArg>({
        query: (queryArg) => ({
          url: `/GridEvent`,
          params: {
            start: queryArg.start,
            end: queryArg.end,
            measuringPoint: queryArg.measuringPoint,
          },
        }),
        providesTags: ["GridEvent"],
      }),
      postGridEvent: build.mutation<
        PostGridEventApiResponse,
        PostGridEventApiArg
      >({
        query: (queryArg) => ({
          url: `/GridEvent`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["GridEvent"],
      }),
      putGridEventById: build.mutation<
        PutGridEventByIdApiResponse,
        PutGridEventByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/GridEvent/${queryArg.id}`,
          method: "PUT",
          body: queryArg.gridEventDto,
        }),
        invalidatesTags: ["GridEvent"],
      }),
      deleteGridEventById: build.mutation<
        DeleteGridEventByIdApiResponse,
        DeleteGridEventByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/GridEvent/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["GridEvent"],
      }),
      getGridEventGetDisconnect: build.query<
        GetGridEventGetDisconnectApiResponse,
        GetGridEventGetDisconnectApiArg
      >({
        query: () => ({ url: `/GridEvent/GetDisconnect` }),
        providesTags: ["GridEvent"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as gridEventApi };
export type GetGridEventApiResponse = /** status 200 OK */ GridEventDto[];
export type GetGridEventApiArg = {
  start?: string;
  end?: string;
  measuringPoint?: string;
};
export type PostGridEventApiResponse = /** status 201 Created */ number;
export type PostGridEventApiArg = GridEventDto;
export type PutGridEventByIdApiResponse = /** status 200 OK */ void;
export type PutGridEventByIdApiArg = {
  id: number;
  gridEventDto: GridEventDto;
};
export type DeleteGridEventByIdApiResponse = unknown;
export type DeleteGridEventByIdApiArg = number;
export type GetGridEventGetDisconnectApiResponse =
  /** status 200 OK */ DisconnectDto[];
export type GetGridEventGetDisconnectApiArg = void;
export type GridEventDto = {
  id: number;
  name: string;
  measuringPoint: string;
  cause: string;
  isPlanned: boolean;
  start: string;
  end: string;
  description: string;
  disconnects: string[];
  comment?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export type DisconnectDto = {
  id: number;
  name: string;
  comment?: string | null;
};
export const {
  useGetGridEventQuery,
  useLazyGetGridEventQuery,
  usePostGridEventMutation,
  usePutGridEventByIdMutation,
  useDeleteGridEventByIdMutation,
  useGetGridEventGetDisconnectQuery,
  useLazyGetGridEventGetDisconnectQuery,
} = injectedRtkApi;
